export default "/public/icons-sprite-4897b62bcaae03658935034a0c804c3f.svg";